import thunkMiddleware from 'redux-thunk';
// import { createStore, applyMiddleware, compose } from 'redux';
import { INITIAL_STATE } from 'skrit-web-framework/constantes';
import { configureStore } from '@reduxjs/toolkit';

import skritApp from '../reducers';

/* Create App Store */
const store = configureStore({
    reducer: skritApp,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(thunkMiddleware),
    preloadedState: INITIAL_STATE,
    devTools:
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__(),
});
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const store = createStore(
//     skritApp,
//     INITIAL_STATE,
//     composeEnhancers(applyMiddleware(thunkMiddleware))
// );

/* End of Create App Store */

export default store;
